// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles-module--hero--2_ZOb","content":"styles-module--content--10uUf"};